import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationResidenceTodoProfilApiService } from './organization-residence-todo-profil-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResidenceTodoProfilApiService extends GeneratedOrganizationResidenceTodoProfilApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
